import UserTypes from 'store/actionTypes/user'
import VehicleModelTypes from 'store/actionTypes/vehicleModel'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {}
}

const vehicleModel = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case VehicleModelTypes.GET_VEHICLE_MODELS_SUCCESS:
      return {
        ...state,
        list: payload?.items || [],
        pagination: payload?.meta || {}
      }
    case VehicleModelTypes.GET_VEHICLE_MODEL_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case VehicleModelTypes.UPDATE_FILTER_VEHICLE_MODEL_SUCCESS:
      return { ...state, filter: payload }

    case VehicleModelTypes.GET_VEHICLE_MODELS_BY_VEHICLE_BRAND_SUCCESS:
      return {
        ...state,
        systems: payload?.items
      }
    case VehicleModelTypes.GET_SYSTEM_VEHICLE_MODELS_SUCCESS:
      return {
        ...state,
        systems: payload?.items
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default vehicleModel
